import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoading: false,
  vacsLength: 0,
  vacs: [],
  vacsError: "",
  formError: "",
}

export default function vaccinesReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_VACCINES:
      return {...state, loading: action.payload };
    case actions.SAVE_LOADING_VACCINES:
      return {...state, saveLoading: action.payload };
    case actions.GET_VACCINES:
      return {...state, vacs: action.payload.vacs, vacsLength: action.payload.vacsLength};
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.VACCINES_FAIL:
      return { ...state, vacsError: action.payload };
    default:
      return state
  }
}